var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('Sidebar'),_c('Header'),_c('div',{staticClass:"content-page",attrs:{"id":"content-page"}},[_c('transition',{attrs:{"name":"router-anim","mode":"out-in","enter-active-class":"animated fadeInUp","leave-active-class":"animated fadeOut"}},[_c('router-view')],1)],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }